export enum IRoles {
  SuperAdmin = "superadmin",
  Admin = "admin",
  Employee = "employee",
  Client = "client",
  Business = "business",
  VR = "virtualReceptionist",
  Manager = "accountManager",
  Other = "other",
}
